import {fetchUserActivePasses} from '../endpoints/api';
import {useQuery} from '@tanstack/react-query';

export function useFetchActivePasses(enabled = true) {
  return useQuery(['active-passes'], () => fetchUserActivePasses(), {
    enabled: enabled,
  });
}
